import { render, staticRenderFns } from "./ViewPayments.vue?vue&type=template&id=f7b25af0&scoped=true"
import script from "./ViewPayments.vue?vue&type=script&lang=js"
export * from "./ViewPayments.vue?vue&type=script&lang=js"
import style0 from "./ViewPayments.vue?vue&type=style&index=0&id=f7b25af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b25af0",
  null
  
)

export default component.exports